<template>
  <v-card
    class="mx-auto"
  >
    <v-list three-line>
      <template v-for="(item) in instrutores">
        <v-subheader
          v-if="item.header"
          :key="item.header"
          v-text="item.header"
        />

        <v-divider
          v-else-if="item.divider"
          :key="item.id"
          :inset="item.inset"
        />

        <v-list-item
          v-else="item.id"
        >
          <v-list-item-avatar>
            <v-img
              :src="require('../../assets/icon_user.png')"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-subtitle> {{ item.nome }} </v-list-item-subtitle>
            <v-list-item-subtitle> {{ item.cpf }} </v-list-item-subtitle>
            <v-list-item-subtitle> {{ item.hasConfig ? 'Click no icone para visualizar configuração de agenda': 'Instrutor não possui uma configuração de agenda' }} </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon @click="viewConfigSchedule(item)">
            <v-icon>
              mdi-account-clock
            </v-icon>
          </v-list-item-icon>
          <v-list-item-icon
            :hidden="!item.hasConfig"
            @click="()=>toCalendar(item)"
          >
            <v-icon>
              mdi-account-arrow-right
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </template>
    </v-list>
    <ScheduleConfig
      v-if="showModal"
      :showModal="showModal"
      :instrutorConfig="instrutorSelected"
      @close="showModal = false"
    />
  </v-card>
</template>
<script>
import ScheduleConfig from './ScheduleConfig';
import InstrutorApi from '../../ws/instrutor';
  export default {
    components:{
        ScheduleConfig,
    },
    data: () => ({
      showModal: false,
      instrutorSelected: {},
      instrutores: [
        { header: 'Instrutores' },
      ],
    }),
    async mounted(){
      const response = await InstrutorApi.findAll();
      response.data.map( async instrutor => {
        //Check exist config Schedule
        const config = await this.getConfig(instrutor);
        instrutor.hasConfig = config.status === 200 ? true : false;
        console.log(instrutor)
        //Create array
        this.instrutores.push(instrutor);
        this.instrutores.push({ divider: true, inset: true });
      });
    },
    methods:{
      async viewConfigSchedule(instrutor){
        const response = await this.getConfig(instrutor);
        if(response.status === 200){
          const config = response.data;
          this.showModal = true;

          config.dias_ativo = config.dias_ativo.split('|');
          config.categorias_ativo = config.categorias_ativo.split('|');

          const configShedule = {
            instrutor,
            config
          };
          this.instrutorSelected = configShedule;
        }else{
          alert(`${response.status} - ${response.data.error}`)
        }

      },
      toCalendar(instrutor){
        this.$router.push(`/instrutor/${instrutor.cpf}/calendar`)
      },
      getConfig(instrutor){
        //VAI DAR RUIM
        //TODO ARRUMAR ISSO
        const response = InstrutorApi.getConfigSchedule(instrutor.cpf);
        return response;
      }
    }
  }
</script>
